import { DetectiveMark } from './DetectiveMark';

/**
 * The game's own identity strip for the full-screen panels.
 *
 * `RTNav` (the ReleaseTEAM site navigation ported from www.releaseteam.com)
 * is rendered separately, as a sibling of `.panel__inner` directly inside
 * `.panel` at each call site — see `src/components/*` for those call sites
 * and `RTNav.tsx` for why it lives outside this constrained, centred
 * container rather than inside it. `BrandHeader` itself is just the game's
 * own mark, kept in its own strip below the site nav rather than merged into
 * it, so the game reads as a ReleaseTEAM thing without pretending its mark is
 * part of the ReleaseTEAM logo.
 *
 * This is the shared identity strip used by every full-screen panel (menus,
 * briefings, sign-in, admin, privacy/attribution notices). It is deliberately
 * NOT used on the two actual-gameplay screens (the image viewer and the
 * rendered board), which keep their own slim `.topbar` with just the small
 * logo: the full nav would eat into the playfield and its `100dvh` layout on
 * a phone, and CLAUDE.md's mobile rules treat that layout as first-class.
 */
export function BrandHeader() {
  return (
    <header className="brandbar">
      <DetectiveMark size={30} className="brandbar__mark" />
      <span className="brandbar__wordmark">Detective</span>
    </header>
  );
}
